(function () {
    function getParent(el, selector) {
        while (!el.classList.contains(selector)) {
            el = el.parentElement;
            if (!el) {
                return null;
            }
        }
        return el;
    }

    function entryIsOpen(el) {
        el = getParent(el, 'hover-map__entry');
        if (!el) {
            return null;
        }
        return el.classList.contains('hover-map__entry--state-active');
    }

    function closeEntry(el) {
        el = getParent(el, 'hover-map__entry');
        if (el) {
            el.classList.remove('hover-map__entry--state-active');
        }
    }

    /**
     * if there are open entry, close them
     */
    function closeAllEntries() {
        let openEntries = document.querySelectorAll('.hover-map__entry--state-active');
        Array.from(openEntries).forEach((el) => {
            closeEntry(el);
        });
    }

    // see also HistoryPage.js
    function getScrollPositionHeaderModifier() {
        let headerHeight = document.querySelector('header')
            ? document.querySelector('header').getBoundingClientRect().height
            : 0;
        return headerHeight + 10;
    }

    function setEntryPopupPosition(contentEl, /*entryEl*/ el) {
        let transformTop;
        let transformLeft;

        if (el.dataset.left < 20) {
            transformLeft = 'left';
        } else if (el.dataset.left > 80) {
            transformLeft = 'right';
        } else {
            transformLeft = 'center';
        }

        contentEl.style.left = '10%';
        contentEl.style.right = '10%';

        if (el.dataset.top < 30) {
            contentEl.style.top = el.dataset.top + '%';
            contentEl.style.bottom = 'unset';
            transformTop = 'top';
        } else if (el.dataset.top > 80) {
            contentEl.style.top = 'unset';
            contentEl.style.bottom = 100 - el.dataset.top + '%';
            transformTop = 'bottom';
        } else {
            contentEl.style.top = '30%';
            contentEl.style.bottom = 'unset';
            transformTop = String(parseInt(el.dataset.top) + 10) + '%';
        }

        contentEl.style.transformOrigin = transformLeft + ' ' + transformTop;
    }

    function openEntry(el) {
        closeAllEntries();

        el = getParent(el, 'hover-map__entry');
        el.classList.add('hover-map__entry--state-active');
        let contentEl = el.querySelector('.hover-map__entry-content');
        setEntryPopupPosition(contentEl, el);

        contentEl.addEventListener('transitionend', onEntryOpend, {
            once: true,
        });
    }

    function showSideBySideEntry(el) {
        closeAllEntries();
        let map = getParent(el, 'hover-map');
        let entryId = el.getAttribute('id');
        if (entryId === map.dataset.selectedEntry) {
            return;
        }
        map.dataset.selectedEntry = entryId;
        let contentEl = map.querySelector('.hover-map__content');
        contentEl.classList.add('hover-map__content-box--visibility-hidden');
        el.classList.add('hover-map__entry--state-active');
        setTimeout(() => {
            contentEl.innerHTML = el.querySelector('.hover-map__entry-content-text').innerHTML;
        }, 250);
        setTimeout(() => {
            contentEl.classList.remove('hover-map__content-box--visibility-hidden');
        }, 500);
    }

    const inBackend = document.body.classList.contains('neos-backend');
    function onPointClick() {
        let el = getParent(this, 'hover-map__entry');
        let map = getParent(el, 'hover-map');
        let isSideBySide = map.classList.contains('hover-map--layout-sidebyside');
        const isEmpty = el.classList.contains('hover-map__entry--empty');
        if (isEmpty) {
            return;
        }
        if (isSideBySide && !inBackend) {
            showSideBySideEntry(el);
            return;
        }

        // default layout
        if (entryIsOpen(this) && !inBackend) {
            closeEntry(this);
        } else {
            openEntry(this);
        }
    }

    // close entries on close icon click
    Array.from(document.querySelectorAll('.hover-map__entry-content-close')).forEach((el) =>
        el.addEventListener(
            'click',
            () => {
                closeEntry(el);
            },
            false
        )
    );

    // toggle entries on click
    Array.from(document.querySelectorAll('.hover-map__entry-point')).forEach((el) =>
        el.addEventListener('click', onPointClick, false)
    );

    // resize
    window.addEventListener('resize', function () {
        requestAnimationFrame(function () {
            Array.from(document.querySelectorAll('.hover-map__entry--state-active')).forEach((el) => {
                let contentEl = el.querySelector('.hover-map__entry-content');
                setEntryPopupPosition(contentEl, el);
            });
        });
    });

    // legend open/close
    const overlayButton = document.querySelector('.hover-map__overlay-button');
    const overlayButtonText = document.querySelector('.hover-map__overlay-button-text');
    const overlayLegend = document.querySelector('.hover-map__overlay-legend');

    if (overlayButton && overlayButtonText && overlayLegend) {
        const showText = overlayButton.dataset.show;
        const closeText = overlayButton.dataset.close;

        overlayButton.addEventListener('click', () => {
            overlayButtonText.innerHTML = overlayButton.classList.contains('hover-map__overlay-button--active')
                ? showText
                : closeText;
            document.querySelector('.hover-map__overlay-button').classList.toggle('hover-map__overlay-button--active');
            document.querySelector('.hover-map__overlay-legend').classList.toggle('hover-map__overlay-legend--active');
        });
    }

    // legend functionality
    const legendList = document.querySelector('.hover-map__overlay-legend-list');
    const legendButton = document.querySelector('.hover-map__overlay-legend-button');
    const legendDeleteAll = document.querySelector('.hover-map__overlay-legend-delete-all');
    const legendShowAll = document.querySelector('.hover-map__overlay-legend-show-all');

    if (legendList && legendButton) {
        const legendItems = document.querySelectorAll('.hover-map__entry-point');
        const shownHoverMapEntries = new Set();

        if (legendDeleteAll) {
            legendDeleteAll.addEventListener('click', () => {
                shownHoverMapEntries.clear();
                Array.from(document.querySelectorAll('.hover-map__overlay-legend-list-item input')).forEach((el) => {
                    el.checked = false;
                });
            });
        }

        if (legendShowAll) {
            legendShowAll.addEventListener('click', () => {
                Array.from(document.querySelectorAll('.hover-map__overlay-legend-list-item input')).forEach((el) => {
                    el.checked = true;
                    shownHoverMapEntries.add(el.name);
                });
            });
        }

        if (legendButton) {
            legendButton.addEventListener('click', () => {
                Array.from(document.querySelectorAll('.hover-map__entry')).forEach((el) => {
                    const name = el.dataset.name;
                    if (shownHoverMapEntries.has(name)) {
                        el.classList.add('hover-map__entry--active');
                    } else {
                        el.classList.remove('hover-map__entry--active');
                    }
                });
            });
        }

        const legendGroups = new Map();
        legendGroups.set('ungrouped', []);
        Object.entries(legendList.dataset).forEach(([group, name]) => {
            legendGroups.set(group, []);
        });

        Array.from(legendItems).forEach((el) => {
            const entryEl = getParent(el, 'hover-map__entry');
            const group = entryEl.dataset.group;
            const name = entryEl.dataset.name;

            const legendItem = document.createElement('div');
            legendItem.classList.add('hover-map__overlay-legend-list-item');
            legendItem.classList.add('hover-map__overlay-legend-list-item--active');
            legendItem.innerHTML = `<label><input type="checkbox" name="${name}"/><span>${name}</span></label>`;

            legendItem.querySelector('input').addEventListener('change', (event) => {
                if (event.target.checked) {
                    shownHoverMapEntries.add(event.target.name);
                } else {
                    shownHoverMapEntries.delete(event.target.name);
                }
            });

            if (legendGroups.has(group)) {
                legendGroups.get(group).push(legendItem);
            } else {
                legendGroups.get('ungrouped').push(legendItem);
            }
        });

        let legendGroupsWithContent = [];
        legendGroups.forEach((items, group) => {
            const legendGroup =
                group === 'ungrouped' ? document.createElement('div') : document.createElement('details');
            legendGroup.classList.add('hover-map__overlay-legend-list-group');

            if (group !== 'ungrouped') {
                legendGroup.innerHTML = `
                    <summary class="hover-map__overlay-legend-list-title">
                        <div class="hover-map__overlay-legend-list-title-icon">
                            <svg class="icon icon--plus"><use xlink:href="#icon-plus"></use></svg>
                            <svg class="icon icon--minus"><use xlink:href="#icon-minus"></use></svg>
                        </div>
                        ${legendList.dataset[group]}
                    </summary>`;
            }

            items.forEach((item) => {
                legendGroup.appendChild(item);
            });
            legendList.appendChild(legendGroup);

            if (legendGroup.querySelector('.hover-map__overlay-legend-list-item--active')) {
                legendGroup.classList.add('hover-map__overlay-legend-list-group--active');
                legendGroupsWithContent.push(legendGroup);
            }
        });

        if (legendGroupsWithContent.length === 1) {
            legendGroupsWithContent[0].open = true;
        }
    }
})();
